// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2c-3";
export var dialog = "_2c-0";
export var divClassnameSwatch = "_2c-8";
export var flexSwatch = "_2c-4";
export var header = "_2c-1";
export var styleAttributeSwatch = "_2c-7";
export var swatch = "_2c-2";
export var textHeaderSwatch = "_2c-5";
export var webSwatch = "_2c-6";